import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './theme.css';
import App from './App.jsx';
import { captureRefParam } from './util/playContract.js';
import { installErrorReporting } from './util/errorReporting.js';

// Stash ?ref/?card BEFORE the router mounts and can strip them, so referral
// attribution survives client-side navigation until the user doc is created
// (deferred to first vote / save). See playContract.readAttributionFromUrl.
captureRefParam();

// R18: forward uncaught errors to the server before anything can crash the
// funnel invisibly. Installed pre-mount so render-time errors are caught too.
installErrorReporting();

// (Sheet-theme accent boot applier removed 2026-06-21 — themes were dropped from
// the web customization shop; --accent now stays at the theme.css gold default.)

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register the service worker (PWA installability now; web-push host in WP4-C).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* SW registration is best-effort — the app works without it */
    });
  });
}
